<template lang="pug">
    .main__section-main
        .main__section-main-img-wr
            img.main__section-main-img(:src="section1.image.path" :alt="section1.image.name" :class="{'main__section-main-img--hide': imgHide}")
        h2.main__section-main-headline(v-html='section1.subtitle')

</template>

<script>
    import EventBus from '@/eventBus';

    import {AjaxHelpersVue} from '@/mixins/AjaxHelpersVue';


    export default {
        name: 'SectionOne',

        mixins: [AjaxHelpersVue],

        props: ['section1'],

        data() {
            return {
                content: null,
                imgHide: true
            }
        },

        components: {
        },

        created() {
            EventBus.$on('imgLoaded', (res) => {
                this.imgHide = res;
            });
        },

        methods: {

        }

    }
</script>

